import { render, staticRenderFns } from "./DetailPanel.vue?vue&type=template&id=7cc94b3b&scoped=true"
import script from "./DetailPanel.vue?vue&type=script&lang=js"
export * from "./DetailPanel.vue?vue&type=script&lang=js"
import style0 from "./DetailPanel.vue?vue&type=style&index=0&id=7cc94b3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc94b3b",
  null
  
)

export default component.exports